import { Component, ErrorHandler, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { SafeUrl } from '@angular/platform-browser'
import { ActivatedRoute, Data, Router } from '@angular/router'

import { MatDialog } from '@angular/material/dialog'

import { Projekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { FirestoreTosite, FirestoreTositteenAlkuperainenTiedosto, FirestoreTositteenKuva, PaymentStatus } from '@lemon/core-firebase/model/tosite'
import { TositeKopioija } from '@lemon/core-firebase/service/tosite/tosite.kopioija'
import { DateService } from '@lemon/core/service/date.service'

import { KayttajaService } from '../_angular/service/kayttaja.service'
import { TositeHakuStateService } from '../_angular/service/tosite-haku-state.service'
import { TositeService } from '../_angular/service/tosite/tosite.service'
import { ProjektitService } from '../_jaettu-angular/projektit.service'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'
import { TositeKuvaCacheService } from '../tositteet/kuvat/tosite-kuva-cache.service'

import { BehaviorSubject, Observable, ReplaySubject, Subject, combineLatest, firstValueFrom, of } from 'rxjs'
import { filter, map, startWith, switchMap, take, takeUntil, tap } from 'rxjs/operators'

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { disabled, FieldTree, form, max, min, required, validate, ValidationError } from '@angular/forms/signals'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ApixReceivedInvoiceConfig } from '@lemon/core-firebase/model/apix'
import { KayttajanTiedot, KirjanpidonPeruste, UserSettings } from '@lemon/core-firebase/model/kayttaja'
import { TypeaheadToimittaja, TypeaheadToimittajaDokumentti } from '@lemon/core-firebase/model/lasku'
import { AsiakasJaettuLemonaidService } from '@lemon/core-firebase/service/asiakas-jaettu-lemonaid.service'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { MaksutService } from '@lemon/core-firebase/service/maksut.service'
import { ToimittajaTunnisteService } from '@lemon/core-firebase/service/lasku/toimittaja-tunniste.service'
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { LocalDate, NumberDate } from '@lemon/core/model/common'
import { BicService } from '@lemon/core/service/bic.service'
import { IbanService } from '@lemon/core/service/iban.service'
import { StringService } from '@lemon/core/service/string.service'
import { LaskunQrKoodinCharacterSet, LaskunQrKoodinOsat, ViitenumeroService, VirtuaaliviivakoodinOsat } from '@lemon/core/service/viitenumero.service'
import { MaksuKatseleComponentData, MaksuKatseleComponentDataResolve, MaksuKatseleComponentExistingData } from 'app/_angular/_resolvers/maksu.resolve'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { LEMONAID_CF_API, LemonHttpService } from 'app/_angular/service/lemon-http.service'
import { UserSettingsService } from 'app/_angular/service/user-settings.service'
import { arvonMuutokset, asetaArvo, nollaa } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { lemonShare } from 'app/_jaettu-angular/_rxjs/lemon-share.operator'
import { FileSaverService } from 'app/_jaettu-angular/service/file-saver'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { VasenValikkoService } from 'app/_jaettu-angular/service/vasen-valikko.service'
import { Big } from 'big.js'
import { LaskunToimittajaTypeaheadBase } from '../_jaettu-angular/service/lasku/typeahead.service'
import { MaksutMaksupaivaDialog, MaksutMaksupaivaDialogData } from './maksut-maksupaiva.dialog'
import { MaksutMaksutapaDialog, MaksutMaksutapaDialogData } from './maksut-maksutapa.dialog'
import { MaksutSharedStateService } from './maksut-shared-state.service'
import { MaksutFirestoreDataSource } from './maksut.firestore.datasource'

type ViewType = 'vastaanotto' | 'hyvaksynta' | 'maksaminen' | 'hyvaksynta-ja-maksaminen' | 'lukossa'
export interface FirestoreKuitinLatausKuva extends FirestoreTositteenKuva {
  ladataan: boolean
  safeUrl: SafeUrl
}

interface MaksunTiedotLomake {
  toimittaja: TypeaheadToimittaja | string | null
  erapvm: Date | null
  summa: number | null
  viesti: string | null
  lisatiedot: string | null
  viite: string
  iban: string
  bic: string
  saaja: string
  toimituspvm: Date | null
  projekti: Projekti | null
}

interface Hyvaksyntatieto {
  placeholder: boolean
  text: string
}

interface Virhetieto {
  icon: string
  text: string
}

@Component({
  templateUrl: './maksut-katsele.component.html',
  styleUrls: ['./maksut-katsele.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaksutKatseleComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()

  lahde: 'osto' | 'myynti' | 'palkka' | 'tiliote'

  // tosite: FirestoreTosite = null
  readonly kuvat = signal<string[]>(null)
  tositeObservable: Observable<FirestoreTosite>
  alkuperaiset: FirestoreTositteenAlkuperainenTiedosto[] = null
  maksuHyvaksyttyObservable: Observable<boolean>

  naytaHylkaaNappiObservable: Observable<boolean>
  naytaHylkaamisenPeruminenNappiObservable: Observable<boolean>
  naytaHyvaksyNappiObservable: Observable<boolean>
  naytaHyvaksynnanPeruminenNappiObservable: Observable<boolean>
  naytaMaksettuMuuallaNappiVainVastaanottoObservable: Observable<boolean>
  naytaMaksettuMuuallaNappiMaksutKaytossaObservable: Observable<boolean>
  naytaMaksettuMuuallaPeruminenNappiObservable: Observable<boolean>
  naytaMuokkaaMaksuaNappiObservable: Observable<boolean>
  naytaKasiteltyNappiObservable: Observable<boolean>
  naytaKasittelynPeruminenNappiObservable: Observable<boolean>
  naytaMerkitseHyvitetyksiNappiObservable: Observable<boolean>
  naytaMerkitseHyvitetyksiPeruminenNappiObservable: Observable<boolean>

  private _maksuaMuokataanSubject: BehaviorSubject<boolean> = new BehaviorSubject(false)
  maksuaMuokataanObservable: Observable<boolean> = this._maksuaMuokataanSubject.asObservable()
  logItemsObservable: Observable<{ hyvaksynnat: Hyvaksyntatieto[]; virheet: Virhetieto[] }>
  kooditObservable: Observable<{ viiva: string; qr: string }>
  viewTypeObservable: Observable<ViewType>
  pagesObservable: Observable<{ curr: number; total: number }>
  onkoSuoriteTaiLaskuperusteinenObservable: Observable<boolean>

  showSumma: boolean = false

  private readonly _kentatPoissa = signal(false)
  private readonly _summaPoissa = signal(false)
  maksunTiedotLomake: FieldTree<MaksunTiedotLomake>

  readonly activeTabIndex = signal<number>(undefined)

  private _dataSource: MaksutFirestoreDataSource
  private _currentViewType: ViewType
  private _saveInFlight = false

  readonly showLisatiedotCheckMark = signal<boolean>(undefined)

  readonly formattedIban = signal('')
  edellinenTab: number = 0
  merkitseMaksetuksiDialogAuki: boolean = false

  // Toimittaja
  naytaToimittajaCheck: boolean = false
  toimittajahaunVihjetekstiObservable: BehaviorSubject<string> = new BehaviorSubject('')
  suodatetutToimittajat: ReplaySubject<TypeaheadToimittaja[]> = new ReplaySubject<TypeaheadToimittaja[]>(1)
  toimittajatMapObservable: Observable<Map<TypeaheadToimittaja['avain'], TypeaheadToimittaja>>
  tositteenToimittajaObservable: Observable<TypeaheadToimittaja | null>
  naytaProjektitObservable: Observable<boolean>
  naytettavatProjektitObservable: Observable<Projekti[]>
  tositteenProjektiObservable: Observable<Projekti | null>

  constructor(
    public _kayttajaService: KayttajaService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _snackbar: MatSnackBar,
    private _dialog: MatDialog,
    private _translationService: LemonTranslationService,
    private _ladataanService: LadataanService,
    private _dateService: DateService,
    private _tositeService: TositeService,
    private _tositeKopioija: TositeKopioija,
    private _tositeKuvaCacheService: TositeKuvaCacheService,
    private _timestampService: TimestampService,
    private _formValidationService: FormValidationService,
    private _maksutSharedStateService: MaksutSharedStateService,
    private _katseleComponentDataResolve: MaksuKatseleComponentDataResolve,
    private _viitenumeroService: ViitenumeroService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _vasenValikkoService: VasenValikkoService,
    private _breakpointObserver: BreakpointObserver,
    private _asiakasJaettuService: AsiakasJaettuLemonaidService,
    private _userSettingsService: UserSettingsService,
    private _ibanService: IbanService,
    private _bicService: BicService,
    private _maksutService: MaksutService,
    private _fileSaverService: FileSaverService,
    private _lemonTranslation: LemonTranslationService,
    private _http: LemonHttpService,
    private _tositeUriService: TositeUriService,
    private _laskuUriService: LaskuUriService,
    private _stringService: StringService,
    private _toimittajaTypeahead: LaskunToimittajaTypeaheadBase,
    private _projektitService: ProjektitService,
    private _hakuStateService: TositeHakuStateService,
    private _toimittajaTunnisteService: ToimittajaTunnisteService,
  ) {
    this._dataSource = this._maksutSharedStateService.getDataSource()
    this.maksunTiedotLomake = form(
      signal<MaksunTiedotLomake>({
        toimittaja: null,
        erapvm: null,
        summa: null,
        viesti: null,
        lisatiedot: null,
        viite: '',
        iban: '',
        bic: '',
        saaja: '',
        toimituspvm: null,
        projekti: null,
      }),
      polku => {
        required(polku.toimittaja)
        validoiReaktiivisesti(polku.toimittaja, this._validateValittuToimittaja)
        required(polku.erapvm)
        required(polku.summa)
        min(polku.summa, 0.01)
        max(polku.summa, 999999.99)
        validate(polku.viite, ({ value, valueOf }) => this._validoiViestiTaiViite(value(), valueOf(polku.viesti)))
        validoiReaktiivisesti(polku.viite, this._validateViitenumero)
        // Signal Formsin maxLength asettaisi tekstikenttään maxlength-attribuutin, joka estäisi kirjoittamasta pidemmälle
        validoiReaktiivisesti(polku.viesti, Validators.maxLength(60))
        validate(polku.viesti, ({ value, valueOf }) => this._validoiViestiTaiViite(value(), valueOf(polku.viite)))
        required(polku.iban)
        validoiReaktiivisesti(polku.iban, this._validateIban)
        required(polku.bic)
        validoiReaktiivisesti(polku.bic, this._validateBic)
        required(polku.saaja)
        disabled(polku.toimittaja, () => this._kentatPoissa())
        disabled(polku.erapvm, () => this._kentatPoissa())
        disabled(polku.summa, () => this._summaPoissa())
        disabled(polku.viesti, () => this._kentatPoissa())
        disabled(polku.viite, () => this._kentatPoissa())
        disabled(polku.bic, () => this._kentatPoissa())
        disabled(polku.iban, () => this._kentatPoissa())
        disabled(polku.saaja, () => this._kentatPoissa())
        disabled(polku.toimituspvm, () => this._kentatPoissa())
        disabled(polku.projekti, () => this._kentatPoissa())
      },
    )
    arvonMuutokset(this.maksunTiedotLomake.iban)
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.formattedIban.set(this._ibanService.formatoiIban(value))
      })

    arvonMuutokset(this.maksunTiedotLomake.toimittaja)
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe((value: string | TypeaheadToimittaja) => {
        if (this._stringService.isString(value)) {
          const kasitelty = this._formValidationService.processValue(value)
          this._toimittajaTypeahead
            .haeJaSuodata(kasitelty, false)
            .then(result => {
              this.suodatetutToimittajat.next(result.suodatetut)
            })
            .catch(err => {
              this._errorHandler.handleError(err)
            })
        }
      })
  }

  @HostListener('document:keydown.arrowright')
  async navigoiSeuraavaan() {
    if (this._saveInFlight || this._maksuaMuokataanSubject.value || !this._dataSource.isInitialized()) {
      return
    }
    this._saveInFlight = true
    const seuraavaMaksu = await this._dataSource.siirrySeuraavaan()
    if (seuraavaMaksu) {
      const existing: MaksuKatseleComponentExistingData = {
        tosite: seuraavaMaksu,
      }
      this._katseleComponentDataResolve.asetaOlemassaolevaData(existing)
      this._router.navigate(['/maksut/', seuraavaMaksu.avain])
    }
    this._saveInFlight = false
  }

  @HostListener('document:keydown.arrowleft')
  async navigoiEdelliseen() {
    if (this._saveInFlight || this._maksuaMuokataanSubject.value || !this._dataSource.isInitialized()) {
      return
    }
    this._saveInFlight = true
    const edellinenMaksu = await this._dataSource.siirryEdelliseen()
    if (edellinenMaksu) {
      const existing: MaksuKatseleComponentExistingData = {
        tosite: edellinenMaksu,
      }
      this._katseleComponentDataResolve.asetaOlemassaolevaData(existing)
      this._router.navigate(['/maksut/', edellinenMaksu.avain])
    }
    this._saveInFlight = false
  }

  ngOnInit() {
    this._breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(
        takeUntil(this._ngUnsubscribe),
        map(br => br.matches),
      )
      .subscribe(isSmallScreen => this._vasenValikkoService.paivitaAuki(!isSmallScreen))

    this._userSettingsService.userSettingsObservable.pipe(take(1)).subscribe(settings => {
      if (settings?.vm === 'qr') {
        this.activeTabIndex.set(0)
      } else if (settings?.vm === 'viiva') {
        this.activeTabIndex.set(1)
      } else if (settings?.vm === 'virtuaaliviiva') {
        this.activeTabIndex.set(2)
      }
    })

    this._maksutSharedStateService.valittuTabObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(value => {
      this.edellinenTab = value
    })

    const dataSourceAlustettu = this._dataSource.isInitialized()
    this.pagesObservable = dataSourceAlustettu
      ? combineLatest([this._dataSource.nykyinenIndeksiObservable, this._dataSource.valittujenRivienMaaraObservable]).pipe(
          map(([nykyinen, maara]) => {
            return { curr: nykyinen, total: maara }
          }),
        )
      : of(null)

    this.toimittajatMapObservable = this._kayttajaService.kayttajanTiedotObservable.pipe(
      filter(kayttajanTiedot => !!kayttajanTiedot),
      switchMap(kayttajanTiedot => {
        return this._firebaseLemonaid
          .firestoreDoc<TypeaheadToimittajaDokumentti>(this._laskuUriService.getTypeaheadToimittajaDokumentinUriNew(kayttajanTiedot.asiakasAvain))
          .listen()
          .pipe(
            map(dokumentti => {
              const toimittajatMap = new Map<string, TypeaheadToimittaja>()
              if (dokumentti) {
                for (const [key, value] of Object.entries(dokumentti)) {
                  toimittajatMap.set(key, { avain: key, ...value })
                }
              }
              return toimittajatMap
            }),
          )
      }),
      lemonShare(),
    )

    this.tositeObservable = combineLatest([this._route.data, this._kayttajaService.kayttajanTiedotObservable]).pipe(
      switchMap(([routeData, kayttaja]) => {
        return this._dataSource.asetaNykyisenKuitinIndex(routeData?.data?.tosite).then(() => {
          return [routeData, kayttaja] as [Data, KayttajanTiedot]
        })
      }),
      switchMap(([routeData, kayttaja]) => {
        if (!routeData?.data?.tosite?.avain || !kayttaja?.asiakasAvain) {
          return of<FirestoreTosite>(null)
        }
        const componentData = routeData.data as MaksuKatseleComponentData
        return this._firebaseLemonaid
          .firestoreDoc<FirestoreTosite>(this._tositeUriService.annaTositteenFirestoreUri(kayttaja.asiakasAvain, componentData.tosite.avain))
          .listen()
          .pipe(startWith(componentData.tosite))
      }),
      lemonShare(),
    )

    this.tositteenToimittajaObservable = combineLatest([this.tositeObservable, this.toimittajatMapObservable]).pipe(
      map(([tosite, toimittajatMap]) => {
        if (!tosite || !tosite.toimittajaAvain || !toimittajatMap) {
          return null
        }
        return toimittajatMap.get(tosite.toimittajaAvain)
      }),
    )

    this.naytaProjektitObservable = this._projektitService.naytaProjektitObservable
    this.naytettavatProjektitObservable = this._projektitService.naytettavatKirjanpitoprojektitObservable

    this.tositteenProjektiObservable = combineLatest([this.tositeObservable, this.naytettavatProjektitObservable]).pipe(
      map(([tosite, projektit]) => {
        if (!tosite || !tosite.projektiAvain || !projektit) {
          return null
        }
        return projektit.find(p => p.avain === tosite.projektiAvain) ?? null
      }),
    )

    const tultuHausta = this._hakuStateService.onkoTultuHakusivulta()
    if (!dataSourceAlustettu && !tultuHausta) {
      this.peruuta()
      return
    }

    const apixConfigObservable = this._kayttajaService.kayttajaObservable.pipe(
      switchMap(kayttaja => {
        if (!kayttaja) {
          return of<ApixReceivedInvoiceConfig>(null)
        }
        return this._firebaseLemonaid.firestoreDoc<ApixReceivedInvoiceConfig>('customers/' + kayttaja.asiakasAvain + '/apix-received-invoice-config/' + kayttaja.asiakasAvain).listen()
      }),
    )

    this.viewTypeObservable = combineLatest([this._kayttajaService.nykyinenAsiakasObservable, this._kayttajaService.kayttajaObservable, this.tositeObservable, apixConfigObservable]).pipe(
      map(([asiakas, kayttaja, tosite, apixConfig]) => {
        let viewType: ViewType = 'lukossa'

        if (!asiakas || !kayttaja?.roolit || !tosite || !apixConfig) {
          return viewType
        }

        viewType = 'vastaanotto'

        if (apixConfig.paymentIsActive) {
          if (kayttaja.roolit.MAKSUT_HYVAKSYJA) {
            viewType = 'hyvaksynta'
          }
          if (kayttaja.roolit.MAKSUT_MAKSAJA) {
            viewType = 'maksaminen'
          }
          if (kayttaja.roolit.MAKSUT_HYVAKSYJA && kayttaja.roolit.MAKSUT_MAKSAJA) {
            viewType = 'hyvaksynta-ja-maksaminen'
          }
        }

        if (tosite.paymentStatus === PaymentStatus.ASIAKAS_HYLKASI || tosite.paymentStatus === PaymentStatus.MAKSETTU || tosite.paymentStatus === PaymentStatus.MAKSETTU_TOISAALLA) {
          viewType = 'lukossa'
        }
        return viewType
      }),
      tap<ViewType>(viewType => (this._currentViewType = viewType)),
    )

    const virtuaaliviivakoodiObservable = this.tositeObservable.pipe(
      map(maksu => {
        if (!maksu) {
          return null
        }
        const params: VirtuaaliviivakoodinOsat = {
          erapvm: this._getDateOrCurrentIfInPast(maksu.dueDate),
          iban: maksu.iban,
          summa: new Big(maksu.sum),
          viitenumero: maksu.viitenumero,
        }
        return this._viitenumeroService.luoSuomalainenVirtuaaliviivakoodi(params)
      }),
    )

    const qrkoodiObservable = this.tositeObservable.pipe(
      map(maksu => {
        if (!maksu) {
          return null
        }
        const params: LaskunQrKoodinOsat = {
          serviceTag: 'BCD',
          version: '001',
          charset: LaskunQrKoodinCharacterSet.UTF8,
          identificationCode: 'SCT',
          bic: maksu.bic,
          iban: maksu.iban,
          maksunSaajaNimi: maksu.seller,
          valuutta: maksu.currency || 'EUR',
          summa: maksu.sum,
          purposeCode: null,
          viitenumero: maksu.viitenumero,
          erapaiva: this._getDateOrCurrentIfInPast(maksu.dueDate),
          remittanceInfo: null,
          lisatiedot: null,
        }
        return this._viitenumeroService.luoSuomalainenQrKoodi(params)
      }),
    )

    this.kooditObservable = combineLatest([virtuaaliviivakoodiObservable, qrkoodiObservable]).pipe(
      map(([viiva, qr]) => {
        return { viiva: viiva, qr: qr }
      }),
    )

    this.maksuHyvaksyttyObservable = combineLatest([this.tositeObservable, this._kayttajaService.nykyinenAsiakasObservable]).pipe(
      map(([tosite, asiakas]) => {
        if (!tosite || !asiakas) {
          return false
        }
        if (
          !asiakas.paymentsNeedsApproval ||
          tosite.paymentStatus === PaymentStatus.MAKSUSSA ||
          tosite.paymentStatus === PaymentStatus.MAKSETTU_TOISAALLA ||
          tosite.paymentStatus === PaymentStatus.ASIAKAS_HYLKASI ||
          tosite.paymentStatus === PaymentStatus.MAKSETTU
        ) {
          return true
        }
        return this._maksutService.onkoMaksuHyvaksytty(tosite, asiakas)
      }),
    )

    this.onkoSuoriteTaiLaskuperusteinenObservable = this._kayttajaService.nykyinenAsiakasObservable.pipe(
      map(asiakas => {
        if (!asiakas?.kirjanpidonPerusteet?.length) {
          return false
        }
        const currentLocalDate = this._dateService.currentLocalDate()
        return this._asiakasJaettuService.onkoKirjanpidonPerusteSuoriteTaiLaskuperusteinen(asiakas, currentLocalDate)
      }),
    )

    this.logItemsObservable = combineLatest([this.tositeObservable, this._translationService.currentLanguageObservable, this._kayttajaService.nykyinenAsiakasObservable]).pipe(
      map(([tosite, kieli, asiakas]) => {
        if (!tosite || !kieli || !asiakas) {
          return { virheet: [], hyvaksynnat: [] }
        }

        const amountOfApprovalsRequired = asiakas.paymentsNumberOfApprovalsRequired ?? 1
        const approvals = Object.values(tosite.einvoiceApprovals ?? {}).sort((a, b) => a.approved.toMillis() - b.approved.toMillis())

        const hyvaksynnat: Hyvaksyntatieto[] = []
        const virheet: Virhetieto[] = []
        const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)

        if (!maksutiedot.reference && !maksutiedot.message) {
          virheet.push({ icon: 'ion-md-warning', text: this._translationService.lokalisoiKielella('maksut.muokkaa.validation.viite.viite-tai-viesti', kieli) })
        }

        if (asiakas.paymentsNeedsApproval) {
          for (let approvalNumber = 0; approvalNumber < amountOfApprovalsRequired; approvalNumber++) {
            if (approvals.length > approvalNumber && approvals[approvalNumber]) {
              const approval = approvals[approvalNumber]
              const text =
                this._translationService.lokalisoiKielella('maksut.katsele.hyvaksytty', kieli) +
                ' ' +
                this._dateService.muotoilePaivaJaAikaDate(approval.approved.toDate(), kieli) +
                ' ' +
                approval.firstName +
                ' ' +
                approval.lastName
              hyvaksynnat.push({ placeholder: false, text: text })
            } else {
              hyvaksynnat.push({ placeholder: true, text: approvalNumber + 1 + '. ' + this._translationService.lokalisoiKielella('maksut.katsele.hyvaksynta-puuttuu', kieli) })
            }
          }
        } else {
          for (const approval of approvals) {
            const text =
              this._translationService.lokalisoiKielella('maksut.katsele.hyvaksytty', kieli) +
              ' ' +
              this._dateService.muotoilePaivaJaAikaDate(approval.approved.toDate(), kieli) +
              ' ' +
              approval.firstName +
              ' ' +
              approval.lastName
            hyvaksynnat.push({ placeholder: false, text: text })
          }
        }

        return { virheet, hyvaksynnat }
      }),
    )

    combineLatest([this.maksuaMuokataanObservable, this.viewTypeObservable, this.tositeObservable])
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(([muokataan, viewType, tosite]) => {
        if (muokataan && (viewType === 'maksaminen' || viewType === 'hyvaksynta' || viewType === 'hyvaksynta-ja-maksaminen' || viewType === 'vastaanotto')) {
          this._kentatPoissa.set(false)
          // Estetään hyvityslaskun summan muokkaus
          this._summaPoissa.set(this._onkoHyvitys(tosite))
        } else {
          this._kentatPoissa.set(true)
          this._summaPoissa.set(true)
        }
      })

    combineLatest([this._kayttajaService.kayttajanTiedotObservable, this.tositeObservable, this.tositteenToimittajaObservable])
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(async ([kayttajanTiedot, tosite, toimittaja]) => {
        if (!tosite || !kayttajanTiedot) {
          return
        }

        await this._startMaksunTiedotForm(tosite, toimittaja)

        this.kuvat.set(this._tositeKuvaCacheService.annaKuvienUrlit(tosite, kayttajanTiedot, 'full'))
        this.alkuperaiset = this.annaAlkuperaiset(tosite)
      })

    this.naytaHyvaksyNappiObservable = combineLatest([this.tositeObservable, this._kayttajaService.kayttajanTiedotObservable, this.viewTypeObservable, this.maksuHyvaksyttyObservable]).pipe(
      map(([tosite, kayttaja, viewType, hyvaksytty]) => {
        if (!viewType || !tosite?.avain || !kayttaja?.uid) {
          return false
        }
        if (hyvaksytty) {
          return false
        }
        if (viewType === 'hyvaksynta' || viewType === 'hyvaksynta-ja-maksaminen') {
          if (tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT || tosite.paymentStatus === PaymentStatus.PANKKI_HYLKASI) {
            if (!tosite.einvoiceApprovals || !tosite.einvoiceApprovals[kayttaja.uid]) {
              return true
            }
          }
        }
        return false
      }),
    )
    this.naytaHyvaksynnanPeruminenNappiObservable = combineLatest([this.tositeObservable, this._kayttajaService.kayttajanTiedotObservable]).pipe(
      map(([tosite, kayttaja]) => {
        if (!tosite || !kayttaja) {
          return false
        }
        if (tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT || tosite.paymentStatus === PaymentStatus.PANKKI_HYLKASI) {
          if (tosite.einvoiceApprovals && kayttaja.uid) {
            return !!tosite.einvoiceApprovals[kayttaja.uid]
          }
        }
        return false
      }),
    )

    this.naytaKasiteltyNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return (tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT) && tosite.sum <= 0
      }),
    )
    this.naytaKasittelynPeruminenNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.KASITELTY && tosite.sum <= 0
      }),
    )

    this.naytaMerkitseHyvitetyksiNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return (tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT) && tosite.sum > 0
      }),
    )
    this.naytaMerkitseHyvitetyksiPeruminenNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.KASITELTY && tosite.sum > 0
      }),
    )

    this.naytaHylkaaNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT || tosite.paymentStatus === PaymentStatus.PANKKI_HYLKASI
      }),
    )
    this.naytaHylkaamisenPeruminenNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.ASIAKAS_HYLKASI
      }),
    )
    this.naytaMaksettuMuuallaNappiVainVastaanottoObservable = combineLatest([this.tositeObservable, this.viewTypeObservable]).pipe(
      map(([tosite, viewType]) => {
        if (!tosite || !viewType) {
          return false
        }
        const naytaMaksettuMuuallaTilat = [PaymentStatus.AVOIN, PaymentStatus.ERAANTYNYT, PaymentStatus.PANKKI_HYLKASI]
        return viewType === 'vastaanotto' && naytaMaksettuMuuallaTilat.includes(tosite.paymentStatus) && tosite.sum > 0
      }),
    )
    this.naytaMaksettuMuuallaNappiMaksutKaytossaObservable = combineLatest([this.tositeObservable, this.viewTypeObservable, this.maksuHyvaksyttyObservable]).pipe(
      map(([tosite, viewType, hyvaksytty]) => {
        if (!tosite || !viewType) {
          return false
        }
        const naytaMaksettuMuuallaTilat = [PaymentStatus.AVOIN, PaymentStatus.ERAANTYNYT, PaymentStatus.PANKKI_HYLKASI]
        return hyvaksytty && (viewType === 'maksaminen' || viewType === 'hyvaksynta-ja-maksaminen') && naytaMaksettuMuuallaTilat.includes(tosite.paymentStatus) && tosite.sum > 0
      }),
    )

    this.naytaMaksettuMuuallaPeruminenNappiObservable = combineLatest([this.tositeObservable]).pipe(
      map(([tosite]) => {
        if (!tosite) {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.MAKSETTU_TOISAALLA && tosite.sum > 0
      }),
    )

    this.naytaMuokkaaMaksuaNappiObservable = combineLatest([this.tositeObservable, this.viewTypeObservable]).pipe(
      map(([tosite, viewType]) => {
        if (!tosite || !viewType || viewType === 'lukossa') {
          return false
        }
        return tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.ERAANTYNYT || tosite.paymentStatus === PaymentStatus.PANKKI_HYLKASI
      }),
    )
  }

  private _validoiViestiTaiViite(arvo: string | null, toinen: string | null): ValidationError | null {
    if ((arvo == null || arvo === undefined || arvo.trim() === '') && (toinen == null || toinen === undefined || toinen.trim() === '')) {
      return { kind: 'viestitaiviite' }
    }
    return null
  }

  private _validateValittuToimittaja: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value && !this._stringService.isString(ctrl.value)) {
      return null
    }
    return { required: true }
  }

  private _validateIban: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    if (!this._ibanService.isValidIban(ctrl.value)) {
      return { invalidiban: true }
    }
  }

  private _validateBic: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    if (!this._bicService.validoiBic(ctrl.value)) {
      return { invalidbic: true }
    }
  }

  private _validateViitenumero: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    if (!this._viitenumeroService.onkoViitenumeroValidi(ctrl.value)) {
      return { viitenumero: true }
    }
    return null
  }

  private _getDateOrCurrentIfInPast(date: NumberDate): LocalDate {
    if (this._dateService.compareNumberDates(date, '<', this._dateService.currentNumberDate())) {
      return this._dateService.currentLocalDate()
    }
    return this._dateService.numberToLocalDate(date)
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  compareProjektit(p1: Projekti, p2: Projekti): boolean {
    return p1 && p2 ? p1.avain === p2.avain : p1 === p2
  }

  // lataaKuitti() {
  //   this._ladataanService.aloitaLataaminen()
  //   return this._httpService.getBinary('/kuittiLataaPdf?a=' + encodeURIComponent('/api/1/kuitit/lataa/pdf/' + this.tosite.avain), LEMONAID_CF_API).then(result => {
  //     const nimi = this._tositeService.annaPdfTiedostonNimi(this.tosite, this._translationService.nykyinenKieli, this.lahde)
  //     this._ladataanService.lopetaLataaminen()
  //     saveAs(result, nimi, { autoBom: false })
  //   }).catch(err => {
  //     this._ladataanService.lopetaLataaminen()
  //     this._errorHandler.handleError(err)
  //   })
  // }

  async peruuta() {
    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    const paluureittiHausta = this._hakuStateService.annaPaluureittiHausta()
    if (paluureittiHausta) {
      this._router.navigateByUrl(paluureittiHausta)
      this._saveInFlight = false
      return
    }

    const segments = await firstValueFrom(this._route.url)
    segments.pop()

    if (this.edellinenTab === 1) {
      this._router.navigate(
        segments.map(segment => segment.path),
        {
          queryParams: { tab: 'maksetut' },
        },
      )
    } else {
      this._router.navigate(segments.map(segment => segment.path))
    }
    this._saveInFlight = false
  }

  private annaAlkuperaiset(tosite: FirestoreTosite): FirestoreTositteenAlkuperainenTiedosto[] {
    if (tosite.alkuperaiset) {
      const alkuperaiset: FirestoreTositteenAlkuperainenTiedosto[] = []
      for (const alkuperaisenAvain of Object.keys(tosite.alkuperaiset)) {
        const alkuperainen = tosite.alkuperaiset[alkuperaisenAvain] as FirestoreTositteenAlkuperainenTiedosto
        alkuperaiset.push(alkuperainen)
      }
      return alkuperaiset
    }
    return null
  }

  async merkitseKasitellyksi(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    try {
      // const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)
      // const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, this._dateService.currentLocalDate())

      if (this._saveInFlight) {
        return
      }
      this._saveInFlight = true

      /** Use copy since the save may be cancelled in the dialog */
      const copy = this._tositeKopioija.kopioiTosite(tosite)
      copy.paymentStatus = PaymentStatus.KASITELTY
      copy.paymentMaksutapa = null

      // const data: MaksutMaksupaivaDialogData = { kuitti: copy, kirjanpidonPeruste: peruste }
      // this._dialog.open<MaksutMaksupaivaDialog, MaksutMaksupaivaDialogData>(MaksutMaksupaivaDialog, { data: data })

      this._ladataanService.aloitaLataaminen()
      try {
        // if (this.data.kirjanpidonPeruste === KirjanpidonPeruste.MAKSU) {
        //   const paymentDateLocal = this._dateService.numberToLocalDate(this._kuitti.paymentDate)
        //   const paymentDateTs = this._timestampService.localDateToTimestamp(paymentDateLocal)

        //   this._kuitti.p = this._kuitti.paymentDate
        //   this._kuitti.pvm = paymentDateTs
        //   this._kuitti.localPvm = paymentDateLocal
        // }
        await this._tositeService.tallennaKuitti(copy)
      } catch (err) {
        this._errorHandler.handleError(err)
        this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
      } finally {
        this._saveInFlight = false
        this._ladataanService.lopetaLataaminen()
      }
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    }
  }

  async maksettuMuuallaMaksutKaytossa(tosite: FirestoreTosite) {
    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    try {
      const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)
      const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, tosite.localPvm)

      /** Use copy since the save may be cancelled in the dialog */
      const copy = this._tositeKopioija.kopioiTosite(tosite)
      copy.paymentStatus = PaymentStatus.MAKSETTU_TOISAALLA
      copy.paymentMaksutapa = null
      const data: MaksutMaksupaivaDialogData = { kuitti: copy, kirjanpidonPeruste: peruste }

      const dialog = this._dialog.open<MaksutMaksupaivaDialog, MaksutMaksupaivaDialogData>(MaksutMaksupaivaDialog, { data: data })
      this.merkitseMaksetuksiDialogAuki = true

      dialog
        .afterClosed()
        .pipe(takeUntil(this._ngUnsubscribe))
        .subscribe(() => {
          this.merkitseMaksetuksiDialogAuki = false
        })
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
    }
  }

  async maksettuYrityksenTililtaVainVastaanotto(tosite: FirestoreTosite) {
    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    try {
      const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)
      const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, tosite.localPvm)

      /** Use copy since the save may be cancelled in the dialog */
      const copy = this._tositeKopioija.kopioiTosite(tosite)
      copy.paymentStatus = PaymentStatus.MAKSETTU_TOISAALLA
      copy.paymentMaksutapa = null
      const data: MaksutMaksupaivaDialogData = { kuitti: copy, kirjanpidonPeruste: peruste }

      const dialog = this._dialog.open<MaksutMaksupaivaDialog, MaksutMaksupaivaDialogData>(MaksutMaksupaivaDialog, { data: data })
      this.merkitseMaksetuksiDialogAuki = true

      dialog
        .afterClosed()
        .pipe(takeUntil(this._ngUnsubscribe))
        .subscribe(() => {
          this.merkitseMaksetuksiDialogAuki = false
        })
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
    }
  }

  async maksettuOmallaRahallaVainVastaanotto(tosite: FirestoreTosite) {
    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    try {
      const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)
      const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, tosite.localPvm)

      /** Use copy since the save may be cancelled in the dialog */
      const copy = this._tositeKopioija.kopioiTosite(tosite)
      copy.paymentStatus = PaymentStatus.MAKSETTU_TOISAALLA
      // copy.paymentMaksutapa = null
      const data: MaksutMaksutapaDialogData = { kuitti: copy, milla: 'omalla', kirjanpidonPeruste: peruste }

      const dialog = this._dialog.open(MaksutMaksutapaDialog, { data: data })
      this.merkitseMaksetuksiDialogAuki = true

      dialog
        .afterClosed()
        .pipe(takeUntil(this._ngUnsubscribe))
        .subscribe(() => {
          this.merkitseMaksetuksiDialogAuki = false
        })
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
    }
  }

  async maksettuToisaallaPeru(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    this._ladataanService.aloitaLataaminen()
    try {
      const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)
      const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, tosite.localPvm)

      const eraantynyt = this._dateService.compareNumberDates(tosite.dueDate, '<', this._dateService.currentNumberDate())
      tosite.paymentStatus = eraantynyt ? PaymentStatus.ERAANTYNYT : PaymentStatus.AVOIN
      tosite.paymentMaksutapa = null
      tosite.paymentDate = null

      if (peruste === KirjanpidonPeruste.MAKSU) {
        const invoiceDateLocal = this._dateService.numberToLocalDate(tosite.invoiceDate)
        const invoiceDateTs = this._timestampService.localDateToTimestamp(invoiceDateLocal)

        tosite.p = tosite.invoiceDate
        tosite.pvm = invoiceDateTs
        tosite.localPvm = invoiceDateLocal
      }

      await this._tositeService.tallennaKuitti(tosite)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  async approvePayment(event?: Event) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    if (this._maksuaMuokataanSubject.value) {
      return
    }
    if (this.merkitseMaksetuksiDialogAuki) {
      return
    }
    if (event?.target) {
      const asHtmlElement = event.target as HTMLElement
      if (asHtmlElement.tagName === 'TEXTAREA' || asHtmlElement.tagName === 'INPUT') {
        return
      }
    }

    this._ladataanService.aloitaLataaminen()

    try {
      if (this._currentViewType === 'hyvaksynta' || this._currentViewType === 'hyvaksynta-ja-maksaminen') {
        const tosite = await firstValueFrom(this.tositeObservable)
        const kayttaja = await this._kayttajaService.getKayttaja()

        if (!tosite.einvoiceApprovals) {
          tosite.einvoiceApprovals = {}
        }

        tosite.einvoiceApprovals[kayttaja.avain] = {
          approved: this._timestampService.now(),
          firstName: kayttaja.etunimi,
          lastName: kayttaja.sukunimi,
        }

        await this._tositeService.tallennaKuitti(tosite)
      }

      if (event) {
        this.navigoiSeuraavaan()
      }
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  async revokePaymentApproval(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    this._ladataanService.aloitaLataaminen()

    try {
      const kayttaja = await this._kayttajaService.getKayttaja()
      const asiakas = await firstValueFrom(this._kayttajaService.nykyinenAsiakasObservable)

      if (!tosite.einvoiceApprovals) {
        tosite.einvoiceApprovals = {}
      }

      if (tosite.einvoiceApprovals[kayttaja.avain]) {
        delete tosite.einvoiceApprovals[kayttaja.avain]
      }

      await this._tositeService.tallennaKuitti(tosite)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  async rejectPayment(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true
    this._ladataanService.aloitaLataaminen()

    try {
      tosite.paymentStatus = PaymentStatus.ASIAKAS_HYLKASI
      await this._tositeService.tallennaKuitti(tosite)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  async rejectPaymentPeru(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true
    this._ladataanService.aloitaLataaminen()

    try {
      tosite.paymentStatus = tosite.dueDate < this._dateService.currentNumberDate() ? PaymentStatus.ERAANTYNYT : PaymentStatus.AVOIN
      tosite.poistettu = false
      await this._tositeService.tallennaKuitti(tosite)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  async cancelPaymentDetailsChanges(tosite: FirestoreTosite) {
    this._maksuaMuokataanSubject.next(false)

    const kentat = this.maksunTiedotLomake
    const toimittaja = await firstValueFrom(this.tositteenToimittajaObservable)
    asetaArvo(kentat.toimittaja, toimittaja ?? null)

    const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)
    asetaArvo(kentat.erapvm, this._dateService.numberToDate(maksutiedot.dueDate))
    asetaArvo(kentat.summa, maksutiedot.amount)
    asetaArvo(kentat.viite, this._viitenumeroService.muotoileViitenumero(maksutiedot.reference) ?? '')
    asetaArvo(kentat.viesti, maksutiedot.message ?? null)
    asetaArvo(kentat.lisatiedot, tosite.selite ?? null)
    asetaArvo(kentat.iban, maksutiedot.iban ?? '')
    asetaArvo(kentat.bic, maksutiedot.bic ?? '')
    asetaArvo(kentat.saaja, maksutiedot.maksunSaajanNimi ?? '')
    asetaArvo(kentat.toimituspvm, this._dateService.numberToDate(tosite.deliveryDate))

    if (tosite.projektiAvain) {
      const projekti = this.naytettavatProjektitObservable
      projekti.pipe(take(1)).subscribe(projektit => {
        const valittuProjekti = projektit.find(p => p.avain === tosite.projektiAvain)
        asetaArvo(kentat.projekti, valittuProjekti ?? null)
      })
    } else {
      asetaArvo(kentat.projekti, null)
    }
  }

  async savePaymentDetailsChanges(tosite: FirestoreTosite) {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (this._saveInFlight) {
      return
    }

    if (!this.maksunTiedotLomake().valid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.maksunTiedotLomake)
      return
    }
    this._saveInFlight = true
    this._ladataanService.aloitaLataaminen()

    try {
      const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)

      const arvot = this.maksunTiedotLomake().value()
      maksutiedot.dueDate = this._dateService.dateToNumber(arvot.erapvm)
      maksutiedot.amount = arvot.summa
      maksutiedot.reference = this._stringService.removeAllWhiteSpaces(arvot.viite) ?? null
      maksutiedot.message = arvot.viesti ?? null
      tosite.selite = arvot.lisatiedot?.trim() ?? null
      maksutiedot.iban = this._stringService.removeAllWhiteSpaces(arvot.iban) ?? null
      maksutiedot.bic = this._stringService.removeAllWhiteSpaces(arvot.bic) ?? null
      maksutiedot.maksunSaajanNimi = arvot.saaja ?? null
      maksutiedot.deliveryDate = this._dateService.dateToNumber(arvot.toimituspvm)

      tosite.maksutiedot = maksutiedot

      const toimittaja = this.valittuToimittaja ? await this._toimittajaTypeahead.annaToimittaja(this.valittuToimittaja.avain) : null
      tosite.toimittajaAvain = toimittaja ? toimittaja.avain : null

      if (arvot.projekti?.avain) {
        tosite.projektiAvain = arvot.projekti.avain
      } else if (tosite.projektiAvain) {
        // Piilotettu projekti ei ole valittavissa, joten tyhjä valinta ei tarkoita sen poistoa
        const naytettavatProjektit = await firstValueFrom(this.naytettavatProjektitObservable)
        if (naytettavatProjektit.some(projekti => projekti.avain === tosite.projektiAvain)) {
          delete tosite.projektiAvain
        }
      }

      await this._tositeService.tallennaKuitti(tosite)
      this.setMaksuaMuokataan(false)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 10000 })
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  private _onkoHyvitys(tosite: FirestoreTosite): boolean {
    return tosite.sum <= 0
  }

  private async _startMaksunTiedotForm(tosite: FirestoreTosite, toimittaja: TypeaheadToimittaja) {
    const kentat = this.maksunTiedotLomake
    const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)
    asetaArvo(kentat.erapvm, this._dateService.numberToDate(maksutiedot.dueDate))
    asetaArvo(kentat.summa, maksutiedot.amount ?? null)
    asetaArvo(kentat.viite, this._viitenumeroService.muotoileViitenumero(maksutiedot.reference) ?? '')
    asetaArvo(kentat.viesti, maksutiedot.message ?? null)
    asetaArvo(kentat.lisatiedot, tosite.selite ?? null)
    asetaArvo(kentat.iban, this._ibanService.formatoiIban(maksutiedot.iban) ?? '')
    asetaArvo(kentat.bic, maksutiedot.bic ?? '')
    asetaArvo(kentat.saaja, maksutiedot.maksunSaajanNimi ?? '')
    asetaArvo(kentat.toimituspvm, this._dateService.numberToDate(tosite.deliveryDate))
    asetaArvo(kentat.toimittaja, toimittaja ?? null)
    if (tosite.projektiAvain) {
      const projektit = await firstValueFrom(this.naytettavatProjektitObservable)
      const valittuProjekti = projektit.find(p => p.avain === tosite.projektiAvain)
      asetaArvo(kentat.projekti, valittuProjekti ?? null)
    } else {
      asetaArvo(kentat.projekti, null)
    }
  }

  async tabGroupIndexChanged(event: number) {
    const valittuMaksukoodi: UserSettings['vm'] = this._mapTabsToMaksukoodit(event)

    /** Don't return, run in background  */
    firstValueFrom(this._userSettingsService.userSettingsObservable).then(settings => {
      if (settings?.vm === valittuMaksukoodi) {
        return
      }
      return this._kayttajaService.getKayttajanTiedot().then(kayttajanTiedot => {
        return this._userSettingsService.setValittuMaksukoodi(valittuMaksukoodi, kayttajanTiedot.asiakasAvain, kayttajanTiedot.uid, this._firebaseLemonaid)
      })
    })
  }

  private _mapTabsToMaksukoodit(idx: number): UserSettings['vm'] {
    if (idx === 0) {
      return 'qr'
    }
    if (idx === 1) {
      return 'viiva'
    }
    if (idx === 2) {
      return 'virtuaaliviiva'
    }
    return null
  }

  setMaksuaMuokataan(state: boolean) {
    this._maksuaMuokataanSubject.next(state)
  }

  async saveLisatiedotChange(tosite: FirestoreTosite) {
    if (this._saveInFlight) {
      return
    }
    this._saveInFlight = true

    try {
      const change = this.maksunTiedotLomake.lisatiedot().value()?.trim() ?? null
      if (change === (tosite.selite ?? null)) {
        return
      }

      tosite.selite = change

      await this._tositeService.tallennaKuitti(tosite)

      this.showLisatiedotCheckMark.set(true)
      setTimeout(() => {
        this.showLisatiedotCheckMark.set(false)
      }, 1500)
    } catch (err) {
      this._errorHandler.handleError(err)
    } finally {
      this._saveInFlight = false
    }
  }

  async lataaLasku(tosite: FirestoreTosite) {
    if (this._saveInFlight) {
      return
    }
    if (!tosite.alkuperaiset) {
      return
    }
    this._saveInFlight = true

    try {
      this._ladataanService.aloitaLataaminen()

      const alkuperaiset = Object.values(tosite.alkuperaiset)
      const alkuperainen = alkuperaiset.find(alkup => alkup.avain.indexOf('laskunkuva') > -1) || alkuperaiset[0]

      const kayttaja = await this._kayttajaService.getKayttajanTiedot()
      const originalUri = this._tositeUriService.annaCloudStorageAlkuperainenUriAsiakasIdlle(kayttaja?.asiakasId, alkuperainen)

      const result = await this._http.getBinary('/lataaOstolasku?a=' + encodeURIComponent(originalUri) + '&time=' + encodeURIComponent(new Date().getTime()), LEMONAID_CF_API)

      const nimi = this._tositeService.annaPdfTiedostonNimiOstotositteenAlkuperaiselle(tosite, this._lemonTranslation.nykyinenKieli)
      this._fileSaverService.saveAs(result, nimi)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._saveInFlight = false
      this._ladataanService.lopetaLataaminen()
    }
  }

  // Toimittaja
  get valittuToimittaja(): TypeaheadToimittaja | null {
    const value = this.maksunTiedotLomake.toimittaja().value()
    return value && !this._stringService.isString(value) ? value : null
  }

  async poistaValittuToimittaja() {
    nollaa(this.maksunTiedotLomake.toimittaja, null)
  }

  onToimittajaPaste(event: ClipboardEvent) {
    setTimeout(() => {
      // Vastaa reaktiivisen lomakkeen updateValueAndValidity-kutsua, joka lähetti kentän nykyisen arvon tilaajille uudelleen
      const toimittaja = this.maksunTiedotLomake.toimittaja
      asetaArvo(toimittaja, toimittaja().value())
    }, 0) // Timeout needed to move the validation to the end of the call stack, i.e. to ensure that new FormControl value is set already when the validation restarts.
  }

  naytettavaTunniste(ytunnus: string | null) {
    return this._toimittajaTunnisteService.naytettavaTunnisteArvosta(ytunnus)
  }

  toimittajaDisplayFn(toimittaja: TypeaheadToimittaja): string {
    if (toimittaja && toimittaja.nimi) {
      return toimittaja.nimi
    }
    return ''
  }
}
